<template>
  <div class="w-full">
    <div class="flex w-full flex-row items-center pb-8">
      <h3 class="text-display-small">Superkraft</h3>
      <div class="ml-auto flex flex-row items-center gap-2">
        <div
          v-if="!hasChanged && slideProperties.updatedAt"
          class="bg-surface-container text-title-medium text-on-surface-variant flex h-14 flex-row items-center rounded-full px-6"
        >
          <BaseIcon class="mr-2">check_circle</BaseIcon>
          Abgeschlossen am {{ useDisplayDate(slideProperties.updatedAt, { dayName: 'none' }) }}
        </div>
        <BaseTextButton
          v-if="hasChanged && slideProperties.updatedAt"
          color="filled"
          size="M"
          icon="cloud_upload"
          @click="updateSlide"
          >Änderungen Speichern</BaseTextButton
        >
        <BaseTextButton
          v-if="!slideProperties.updatedAt"
          color="filled"
          size="M"
          icon="check_circle"
          @click="updateSlide"
          >Abschliessen</BaseTextButton
        >
      </div>
    </div>
  </div>
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
    <div v-if="superpower">
      <DialogSuperpower :superpower="superpower" />
    </div>
    <div
      v-else
      class="bg-surface-container rounded-large flex h-full flex-col items-center justify-center p-4"
    >
      <p v-if="superpowerSurveyId" class="text-body-large text-on-surface-variant p-4 text-center">
        Du hast eine laufende Umfrage zu deine Superkraft! Schliesse diese ab um die Superkraft zu
        sehen.
      </p>
      <p v-else class="text-body-large text-on-surface-variant p-4 text-center">
        Du hast deine Superkraft noch nicht herausgefunden. Finde sie am besten jetzt gleich heraus!
      </p>
      <BaseTextButton
        class="mt-2"
        color="filled"
        size="M"
        @click="handleSuperpowerSurvey(feedbackTopicId, superpowerSurveyId)"
        >Superpower herausfinden</BaseTextButton
      >
    </div>
    <SelectSpontaneousFeedbacksSection
      v-model="inputData.spontaneousFeedbackIds"
      :spontaneous-feedbacks="spontaneousFeedbacks"
    />
  </div>
</template>
<script lang="ts" setup>
  import { useRouter } from 'vue-router'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import { useStartSelfFeedback } from '@/modules/start-self-feedback/use-start-self-feedback'
  import { useUserStore } from '../../../stores/user.store'
  import DialogSuperpower from './DialogSuperpower.vue'
  import SelectSpontaneousFeedbacksSection from './SelectSpontaneousFeedbacksSection.vue'
  import type { JSONContent } from '@tiptap/vue-3'
  import { usePrepareSuperpowerSlideAnalysis } from '../composable/use-prepare-superpower-slide-analysis'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import { watch } from 'vue'

  interface Props {
    feedbackTopicId: string
    superpowerSurveyId?: string
    superpower?: {
      id: string
      title: string
      color: string
      image?: string
      date: string
    }
    spontaneousFeedbacks: ReadonlyArray<{
      id: string
      senderId?: string
      text: JSONContent
      date: string
    }>
    slideProperties: {
      updatedAt: string | null
      spontaneousFeedbackIds: Array<string>
    }
  }
  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'dirty', value: boolean): void
  }>()

  const { hasChanged, updateSlide, inputData } = usePrepareSuperpowerSlideAnalysis(
    props.feedbackTopicId,
    props.slideProperties,
  )

  watch(hasChanged, (value) => {
    emit('dirty', value)
  })

  const router = useRouter()
  const { user } = useUserStore()
  const { selfFeedbackFormData, startSelfFeedback, clearForm } = useStartSelfFeedback()

  const handleSuperpowerSurvey = async (feedbackTopicId: string, surveyId?: string) => {
    if (surveyId) {
      router.push({
        name: 'feedback',
        params: { surveyId: surveyId, receiverId: user.id },
      })
      return
    }
    selfFeedbackFormData.templateIds = [feedbackTopicId]

    await startSelfFeedback()

    clearForm()
  }
</script>
